<div class="aikosh-wrapper">
  <!-- BG Image Section -->
  <div class="aikosh-hero">
    <!-- BG Image -->
    <img
      [src]="aikoshAssets.background"
      class="bg-svg"
      alt="background"
    />

    <!-- Top Left - Ellipse + Vector -->
    <div class="top-left-wrapper">
      <img src="/images/ellipse1.svg" class="ellipse-left-overlay" alt="ellipse" />
      <img src="/images/vector.svg" class="vector-left-overlay" alt="vector" />
    </div>

    <!-- Bottom Right - Ellipse + Vector -->
    <div class="bottom-right-wrapper">
      <img src="/images/ellipse1.svg" class="ellipse-right-overlay" alt="ellipse" />
      <img src="/images/vector-right.svg" class="vector-right-overlay" alt="vector" />
    </div>

    <!-- Content Layer -->
    <div class="container content-layer">
      <div class="row align-items-center min-vh-100 py-5">
        <!-- Left Content -->
        <div class="col-lg-5 col-md-12 left-content">
          <h1 class="main-title">ABOUT AIKosh</h1>
          <h3 class="sub-title">
            India's National Platform for AI Datasets & Innovation
          </h3>
          <p class="description">
            AIKosh is IndiaAI's national platform for AI-ready datasets, models,
            toolkits, and AI development resources.
          </p>
        </div>

        <!-- Right Content -->
        <div class="col-lg-7 col-md-12 right-content">
          <p class="platform-text">
            The platform enables students, researchers, and developers to:
          </p>

          <!-- Dynamic Cards Wrapper -->
          <div class="cards-wrapper">
            <div class="feature-card" *ngFor="let card of featureCards">
              <div class="card-icon">
                <div class="icon-placeholder">
                  <!-- Dynamic Image Src Binding -->
                  <img
                    [src]="card.icon"
                    alt="icon"
                    onerror="this.style.display='none'"
                  />
                </div>
              </div>
              <div class="card-text">
                <h5>{{ card.title }}</h5>
                <p>{{ card.description }}</p>
              </div>
            </div>
          </div>

        </div>
        <!-- /Right Content -->
      </div>
    </div>
  </div>
</div>